export default {
  en: {
    title: 'Chat',
  },

  ru: {
    title: 'Чат',
  },
}
